import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import pro from "../../../images/splash/prof.png";
import axios from "axios";
import { var_api } from "../../constant";
import Modal from 'react-bootstrap/Modal';
import Loader from "../Loader";
import Pagination from 'react-js-pagination';
import React, { useState, useEffect,useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { Step } from '@material-ui/core';

const ServiceEmployeeMaster = () => {
  const [roleName, setRoleName] = useState('');
  const [roleDescription, setRoleDescription] = useState('');
  const [totalEmployees, setTotalEmployee] = useState([]);
  const [employees, setEmployee] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [show, setShow] = useState(false);
  const [roleToDelete, setRoleToDelete] = useState(null);
  const [isLogin, setIsLogin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; 
   const [totalItems, setTotalItems] = useState(0);
  const [startIndex, setStartIndex] = useState(0);
  const [ searchQuery,setSearchQuery] = useState('');
  const [roles, setRoles] = useState([]);
  const history = useHistory();
  const [employeeid, setEmployeeid] = useState('');
  const [employeeName, setEmployeeName] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedRoleName, setSelectedRoleName] = useState('');
  const [currentRoleId, setCurrentRoleId] = useState(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [profile, setProfile] = useState(null);
  const [id_proof, setIdproof]  =useState(null);
  const [dob, setDob] = useState('');
  const [employeestatus, setemployeeStatus] = useState(null);
  const [gender, setGender] = useState("");
  const [is_beautician, setIS_beautician] = useState(false);
  const profileInputRef = useRef(null);  // Ref for profile file input
  const idProofInputRef = useRef(null);
  const [errors, setErrors] = useState({});


  useEffect(() => {
    fetchEmployeeData();
    fetchRoleData();
}, [currentPage]);

const fetchRoleData = async () => {
  const token = localStorage.getItem('token');
  setIsLogin(true);
  try {
      const response = await axios.get(`${var_api}/api/role-master/get`, {
          headers: {
              'Authorization': `${token}`
          }
      });
      setRoles(response.data);
      
      setIsLogin(false);
  } catch (error) {
      setRoles([]);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
  }
};
const fetchEmployeeData = async () => {
  const token = localStorage.getItem('token');
  const startIndexCalc = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndexCalc + itemsPerPage;
  setIsLogin(true);
  try {
    const response = await axios.get(`${var_api}/api/employee/get`, {
      headers: {
        'Authorization': `${token}`,
      },
    });
    const employeemaster = response.data;

    if (employeemaster.length > 0) {
      const nonAdminEmployees = employeemaster.filter(employee => employee.employee_role !== 'Admin');
      setTotalEmployee(nonAdminEmployees); // Store the full list without admin employees
      const paginatedEmployees = nonAdminEmployees.slice(startIndexCalc, endIndex);
      setEmployee(paginatedEmployees);
      setTotalItems(nonAdminEmployees.length); // Update total items based on filtered employees
      setStartIndex(startIndexCalc); // Update startIndex state variable
    } else {
      console.log('No data found.');
      setEmployee([]);
      setTotalItems(0);
      setStartIndex(0); // Reset startIndex state variable
    }
    setIsLogin(false);
  } catch (error) {
    if (error.response && error.response.status === 401) {
      history.push('/signin');
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response?.data?.error || 'Something went wrong!',
        confirmButtonColor: '#007500',
      });
    }
    setEmployee([]);
    setIsLogin(false);
  }
};

const validateForm = () => {
  const newErrors = {};

  if (!employeeName) newErrors.employeeName = 'Employee Name is required';
  if (!phoneNo) newErrors.phoneNo = 'Phone number is required';
  if (!selectedRole) newErrors.selectedRole = 'Role is required';
  if (!email) newErrors.email = 'Email is required';
  if (!password) newErrors.password = 'Password is required';
  if (!dob) newErrors.dob = 'Date of Birth is required';
  if (!gender) newErrors.gender = 'Gender is required';

  return newErrors;
};


const createEmployee = async () => {

  const newErrors = validateForm();
  setErrors(newErrors); // Update the state with validation errors

  // If there are errors, don't proceed with the form submission
  if (Object.keys(newErrors).length > 0) {
    return;
  }

  const token = localStorage.getItem('token');
  setIsLogin(true);

  // Find the selected role object based on the selectedRole ID
  const selectedRoleObj = roles.find(role => role.id === parseInt(selectedRole));

  // // Check if selectedRoleObj is found
  // if (!selectedRoleObj) {
  //   console.error('Selected role not found');
  //   alert('Selected role not found')
  //   setIsLogin(false);
  //   return;
  // }


  // Create a new FormData object
  const formData = new FormData();
  formData.append('name', employeeName);
  formData.append('mobile_no', phoneNo);
  formData.append('employee_role', selectedRoleObj.role_name); // Use role_name from selectedRoleObj
  formData.append('email', email);
  formData.append('password', password);
  formData.append('profile_image', profile);
  formData.append('role_id', selectedRole); // Use the selectedRole ID directly
  formData.append('id_proof', id_proof);
  formData.append('gender', gender);
  formData.append('dob', dob);
  formData.append('is_beautician',is_beautician);
  formData.append('is_active',1);
  formData.append('is_doctor',0);
  formData.append('doc_id',0);
  formData.append('available_status',1);

  try {
    const response = await axios.post(`${var_api}/api/employee/post`, formData, {
      headers: {
        'Authorization': `${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });

    if (response.status === 200) {
      Swal.fire({
        icon: 'success',
        text: 'Employee Created Successfully',
        confirmButtonColor: '#007500',
      });
      console.log('Employee created successfully!');
    }
    fetchEmployeeData();
    resetForm();
  } catch (error) {
    console.error('Error:', error);
    if (error.response && error.response.status === 401) {
      history.push('/signin');
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response?.data?.error || 'Something went wrong!',
        confirmButtonColor: '#007500',
      });
    }
  } finally {
    setIsLogin(false);
  }
};

const updateEmployee = async () => {
  const token = localStorage.getItem('token');
  setIsLogin(true);
  
  const newErrors = validateForm();
  setErrors(newErrors); // Update the state with validation errors

  // If there are errors, don't proceed with the form submission
  if (Object.keys(newErrors).length > 0) {
    return;
  }

  // Find the selected role object based on the selectedRole ID
  // const selectedRoleObj = roles.find(role => role.id === parseInt(selectedRole));

  // // Check if selectedRoleObj is found
  // if (!selectedRoleObj) {
  //   console.error('Selected role not found');
  //   setIsLogin(false);
  //   return;
  // }


  // if (!employeeName || !phoneNo || !selectedRole || !email || !password) {
  //   alert("Please fill all the required fields.");
  //   setIsLogin(false);
  //   return;
  // }


  // Create a new FormData object
  const formData = new FormData();
  // if (employeestatus !== null) {
  //   formData.append('available_status', employeestatus);
  // } else {
    formData.append('name', employeeName);
    formData.append('mobile_no', phoneNo);
    formData.append('employee_role', selectedRoleName); // Use role_name from selectedRoleObj
    formData.append('email', email);
    formData.append('password', password);
    formData.append('profile_image', profile);
    formData.append('role_id', selectedRole); // Use the selectedRole ID directly
    formData.append('available_status', employeestatus);
    formData.append('gender',gender);
    formData.append('dob',dob);
    formData.append('is_beautician', is_beautician);
    formData.append('is_active',1);
    formData.append('is_doctor',0);
    formData.append('doc_id',0);
  // }

  try {
    const response = await axios.put(`${var_api}/api/employee/put/${employeeid}`, formData, {
      headers: {
        'Authorization': `${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });

    if (response.status === 200) {
      Swal.fire({
        icon: 'success',
        text: 'Employee Updated Successfully',
        confirmButtonColor: '#007500',
      });
      console.log('Employee updated successfully!');
    }
    fetchEmployeeData();
    resetForm();
  } catch (error) {
    console.error('Error:', error);
    if (error.response && error.response.status === 401) {
      history.push('/signin');
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response?.data?.error || 'Something went wrong!',
        confirmButtonColor: '#007500',
      });
    }
  } finally {
    setIsLogin(false);
  }
};

const handleStatusChange = async (employee, newStatus) => {
  const token = localStorage.getItem('token');
  setIsLogin(true);

  // Create a new FormData object
  const formData = new FormData();
  // if (status !== null) {
    formData.append('available_status', newStatus);
  // } else {
    formData.append('name', employee.name);
    formData.append('mobile_no', employee.mobile_no);
    formData.append('employee_role', employee.employee_role); // Use role_name from selectedRoleObj
    formData.append('email', employee.email);
    formData.append('password', employee.password);
    formData.append('profile_image', employee.profile_image);
    formData.append('role_id', employee.role_id); // Use the selectedRole ID directly
    formData.append('dob',employee.dob);
    formData.append('gender',employee.gender);
    formData.append('is_beautician', employee.is_beautician);
    formData.append('is_doctor',employee.is_doctor);
    formData.append('doc_id',employee.doc_id);
    formData.append('is_active',employee.is_active);
  // }

  try {
    const response = await axios.put(`${var_api}/api/employee/put/${employee.id}`, formData, {
      headers: {
        'Authorization': `${token}`,
         'Content-Type': 'multipart/form-data'
      }
    });

    if (response.status === 200) {
      Swal.fire({
        icon: 'success',
        text: 'Employee Updated Successfully',
        confirmButtonColor: '#007500',
      });
      console.log('Employee updated successfully!');
    }
    fetchEmployeeData();
  } catch (error) {
    console.error('Error:', error);
    if (error.response && error.response.status === 401) {
      history.push('/signin');
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response?.data?.error || 'Something went wrong!',
        confirmButtonColor: '#007500',
      });
    }
  } finally {
    setIsLogin(false);
  }
};

const handleOpenConfirmation = (employeeId) => {
    setRoleToDelete(employeeId);
    setShow(true);
};

const handleCloseConfirmation= ()=>{
    setShow(false)
  };
  const resetForm = () => {
    setEmployeeName('');
    setPhoneNo('');
    setSelectedRole('');
    setEmail('');
    setPassword('');
    // setProfile(null);
    setEditMode(false);
    setCurrentRoleId(null);
    setIS_beautician(false);
    setDob('');
    setGender('');  // Assuming you set profile file
    // setIdproof(null); 
    if (profileInputRef.current) {
      profileInputRef.current.value = '';  // Clear file input
    }
    if (idProofInputRef.current) {
      idProofInputRef.current.value = '';  // Clear file input
    }
};

const handleDelete = async () => {
    const token = localStorage.getItem('token');
    setIsLogin(true);
    try {
        await axios.delete(`${var_api}/api/employee/delete/${roleToDelete}`, {
            headers: {
                'Authorization': `${token}`
            }
        });
        console.log('Role deleted successfully!');
        fetchEmployeeData();
        handleCloseConfirmation();
        setIsLogin(false);
    } catch (error) {
        console.error('Error deleting role:', error);
        if (error.response && error.response.status === 401) {
            history.push('/signin');
        }
    }
};

const handleFileChange = (e) => {
  setProfile(e.target.files[0]);
};

const handleFileChangeProof = (e) => {
  setIdproof(e.target.files[0]);
};

const handleEdit = (employee) => {
    setEditMode(true);
    setEmployeeid(employee.id);
    setEmployeeName(employee.name);
    setPhoneNo(employee.mobile_no);
    setEmail(employee.email);
    setPassword(employee.password); // Leave password empty for security
    setProfile(employee.profile_image); // Reset profile for file upload
    setSelectedRole(employee.role_id);
    setemployeeStatus(employee.available_status);
    setSelectedRoleName(employee.employee_role);
    setDob(employee.dob);
    setGender(employee.gender);
    setIS_beautician(employee.is_beautician);

  };

  const handleSearchInput = (e) => {
    setSearchQuery(e.target.value);
  };
  
  // Filter employees before applying pagination
  const filteredEmployees = Array.isArray(totalEmployees) && totalEmployees.filter(employee => {
    const searchLower = searchQuery.toLowerCase();
    return (
      (employee.name && employee.name.toString().toLowerCase().includes(searchLower)) ||
      (employee.email && employee.email.toString().toLowerCase().includes(searchLower)) ||
      (employee.employee_role && employee.employee_role.toString().toLowerCase().includes(searchLower)) ||
      (employee.mobile_no && employee.mobile_no.toString().toLowerCase().includes(searchLower))
    );
  });
  
  // Apply pagination to the filtered list
  const paginatedFilteredEmployees = filteredEmployees.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  

     // Handler to update state when a role is selected
     const handleRoleChange = (e) => {
      const roleId = e.target.value;
      const roleName = e.target.options[e.target.selectedIndex].text;
  
      setSelectedRole(roleId);
      setSelectedRoleName(roleName);
  
      // Check if the selected role is "Beautician" and update checkbox state
      const selectedRoleObj = roles.find((role) => role.role_name === roleName);
      if (selectedRoleObj && selectedRoleObj.role_name === 'Beautician') {
        setIS_beautician(1); // Check the checkbox if "Beautician" is selected
      } else {
        setIS_beautician(0); // Uncheck the checkbox for other roles
      }
    };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); // Update current page
  };

  const handleBeauticianChange = (e) => {
    const isChecked = e.target.checked;
    setIS_beautician(isChecked ? 1 : 0);

    if (isChecked) {
      // Automatically select "Beautician" role and disable dropdown
      const beauticianRole = roles.find((role) => role.role_name === 'Beautician');
      if (beauticianRole) {
        setSelectedRole(beauticianRole.id);
      }
    } else {
      // Clear selection and enable dropdown
      setSelectedRole('');
    }
  };

    return(
        <>
        {isLogin && <Loader />}
        <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
       EMPLOYEE MASTER
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>
<br/>
<br/>
         <div style={{margin:"auto",padding:"20px"}}>
             <Row>
             <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
             <Card style={{ border: "none", maxWidth: "28rem", padding: "15px 27px", margin: "auto", height: "auto", borderRadius: "20px", boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgb(89, 128, 71, 0.50) 0px 3px 6px" }}>
            <Card.Body>
                <h5 style={{ textAlign: "center", color: "rgb(89, 128, 71)", fontWeight: "bold" }}>{editMode ? 'Edit Employee' : 'Create Employee'}</h5>
                <Form onSubmit={(e) => e.preventDefault()}>
                    <Form.Group controlId="formBasicName" className="mt-3">
                        <Form.Label>Employee Name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter Employee Name"
                            name="employeeName"
                            value={employeeName}
                            onChange={(e) =>  setEmployeeName(e.target.value)}
                            required
                        />
                         {errors.employeeName && <p style={{ color: 'red' }}>{errors.employeeName}</p>}
                    </Form.Group>

                    <Form.Group controlId="formBasicBeautician" className="mt-3 d-flex justify-content-end">
        <Form.Check
          inline
          type="checkbox"
          label="is_beautician"
          name="isBeautician"
          value="1"
          checked={is_beautician === 1} // Reflect 1 as checked
          onChange={handleBeauticianChange} // Update state on change
        />
      </Form.Group>



                    <Form.Group controlId="formBasicPhone" className="mt-3">
                        <Form.Label>Phone No</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Enter Phone no"
                            name="phoneNo"
                            value={phoneNo}
                            onChange={(e) =>  setPhoneNo(e.target.value)}
                            required
                        />
                        {errors.phoneNo && <p style={{ color: 'red' }}>{errors.phoneNo}</p>}
                    </Form.Group>
                    <Form.Group controlId="formBasicEmail" className="mt-3">
        <Form.Label>Select Role</Form.Label>
        <Form.Control
          as="select"
          name="selectedRole"
          value={selectedRole}
          onChange={handleRoleChange}
          required
        >
          <option value="">Select Role</option>
          {roles.map((role, index) => (
            <option key={index} value={role.id}>
              {role.role_name}
            </option>
          ))}
        </Form.Control>
        {errors.selectedRole && <p style={{ color: 'red' }}>{errors.selectedRole}</p>}
      </Form.Group>

                    <Form.Group controlId="formBasicEmail" className="mt-3">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter email"
                            name="email"
                            value={email}
                            onChange={(e) =>  setEmail(e.target.value)}
                            required
                        />
                        {errors.email && <p style={{ color: 'red' }}>{errors.email}</p>}
                    </Form.Group>

                    <Form.Group controlId="formBasicPassword" className="mt-3">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder="Password"
                            name="password"
                            value={password}
                            onChange={(e) =>  setPassword(e.target.value)}
                            required
                        />
                        {errors.password && <p style={{ color: 'red' }}>{errors.password}</p>}
                    </Form.Group>

                    <Form.Group controlId="formBasicPassword" className="mt-3">
                        <Form.Label>DOB</Form.Label>
                        <Form.Control
                            type="date"
                            placeholder="date"
                            name="dob"
                            value={dob}
                            onChange={(e) =>  setDob(e.target.value)}
                            required
                        />
                         {errors.dob && <p style={{ color: 'red' }}>{errors.dob}</p>}
                    </Form.Group>


                    <Form.Group controlId="formBasicGender" className="mt-3">
    <Form.Label>Gender</Form.Label>
    <div>
      <Form.Check
        inline
        type="radio"
        label="Male"
        name="gender"
        value="Male"
        checked={gender === "Male"}
        onChange={(e) => setGender(e.target.value)}
      />
      <Form.Check
        inline
        type="radio"
        label="Female"
        name="gender"
        value="Female"
        checked={gender === "Female"}
        onChange={(e) => setGender(e.target.value)}
      />
      <Form.Check
        inline
        type="radio"
        label="Other"
        name="gender"
        value="Other"
        checked={gender === "Other"}
        onChange={(e) => setGender(e.target.value)}
      />
    </div>
    {errors.gender && <p style={{ color: 'red' }}>{errors.gender}</p>}
  </Form.Group>

                    <Form.Group controlId="formBasicProfile" className="mt-3">
                        <Form.Label>Employee Profile</Form.Label>
                        <Form.Control
                            type="file"
                            placeholder="Select File"
                            name="profile"
                            onChange={handleFileChange}
                            ref={profileInputRef}
                        />
                    </Form.Group>

                    <Form.Group controlId="formBasicProfile" className="mt-3">
                        <Form.Label>ID Proof</Form.Label>
                        <Form.Control
                            type="file"
                            placeholder="Select File"
                            name="id_proof"
                            onChange={handleFileChangeProof}
                            ref={idProofInputRef}
                        />
                    </Form.Group>

                    {/* <Button variant="primary" type="submit" className="mt-3" style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }} onClick={employeeMasterpost}>
                        {editMode ? 'Update' : 'Submit'}
                    </Button>{" "} */}
                     <Button
      variant="primary"
      type="button"
      className="mt-3"
      style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }}
      onClick={createEmployee}
      hidden={editMode}  // This will hide the Submit button when editMode is true
    >
      Submit
    </Button>{" "}

    <Button
      variant="primary"
      type="button"
      className="mt-3"
      style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }}
      onClick={() => updateEmployee()}
      hidden={!editMode}  // This will hide the Update button when editMode is false
    >
      Update
    </Button>{" "}

                    <Button variant="danger" type="button" className="mt-3" onClick={resetForm}>
                        Reset
                    </Button>
                </Form>
            </Card.Body>
        </Card>
</Col>
                <Col xs={12} md={6} lg={6} xl={8} xxl={8} style={{padding:"0px",margin:"0px"}}>
                <Card style={{ border: "none", maxWidth:"62rem", padding:"20px", margin:"auto", height:"auto", borderRadius:"20px", fontFamily:"Arial, Helvetica, sans-serif" }}>
                 <h5 style={{color:"rgb(89, 128, 71)", fontWeight:"bold"}}>Employee List  <span style={{float:"right", fontSize:"17px", color:"black", fontWeight:"bold"}}><Form.Control type="text" placeholder="Search..."  onChange={handleSearchInput}/></span> </h5>  
                 <div style={{float:"left"}}>
                 <span style={{fontSize:"17px", color:"rgba(50, 103, 19)"}}>No.Of.Employees: {totalEmployees.length}</span>
                    </div> 
        <Table responsive className="mt-3">
          <thead>
            <tr>
              <th>S.No</th> 
              <th>Profile</th>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Phone</th>
              <th>Availability Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
  {paginatedFilteredEmployees.length > 0 ? (
    paginatedFilteredEmployees.map((employee, index) => (
      <tr key={employee.id}>
        <td>{startIndex + index + 1}</td>
        <td>
          <img src={`${var_api}/${employee.profile_image}`} alt="No Image" width="50px" height="50px" />
        </td>
        <td>{employee.name}</td>
        <td>{employee.email}</td>
        <td>{employee.employee_role}</td>
        <td>{employee.mobile_no}</td>
        <td>
          <Form.Check
            type="switch"
            id={`custom-switch-${employee.id}`}
            label=""
            checked={employee.available_status === 1}
            onChange={(e) => handleStatusChange(employee, e.target.checked ? 1 : 0)}
          />
        </td>
        <td>
          <Button variant="primary" className="m-1" onClick={() => handleEdit(employee)}>
            <i className="bi bi-pencil-square"></i>
          </Button>
          <Button variant="danger" className="m-1" onClick={() => handleOpenConfirmation(employee.id)}>
            <i className="bi bi-trash"></i>
          </Button>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="7" className="text-center">No data available</td>
    </tr>
  )}
</tbody>
</Table>
<Pagination
  activePage={currentPage}
  itemsCountPerPage={itemsPerPage}
  totalItemsCount={filteredEmployees.length} // Update total count to reflect filtered data
  pageRangeDisplayed={5}
  onChange={handlePageChange}
  itemClass="page-item"
  linkClass="page-link"
  innerClass="pagination justify-content-end"
  activeClass="active-pagination"
/>
      </Card>
                </Col>
            </Row>
        </div>
        <Modal
        show={show}
        onHide={handleCloseConfirmation}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(103, 120, 95, 0.367)",padding:"12px"}}>
          <Modal.Title  style={{fontFamily:"serif",fontWeight:"bolder",marginLeft:"190px"}}>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px",backgroundColor:"white"}}>
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure You want to Delete ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={handleCloseConfirmation}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
      </Modal>
        </>
    )
}

export default ServiceEmployeeMaster;